var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPowerPrdct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 402,
    height: 402,
    viewBox: "0 0 402 402",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2951_135",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 0,
    width: 302,
    height: 402
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M334.979 0C344.24 0 351.75 7.50858 351.75 16.7709V385.229C351.75 394.49 344.24 402 334.979 402H67.0001C57.7493 402 50.25 394.5 50.25 385.249V217.75C50.25 208.499 57.7493 201 67.0001 201H131.906V117.25C131.906 107.999 139.406 100.5 148.656 100.5H213.562V16.7709C213.562 7.50861 221.071 0 230.333 0H334.979Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2951_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.75 16.7709V385.229C351.75 394.49 344.24 402 334.979 402H230.333C221.071 402 213.562 394.49 213.562 385.229V16.7709C213.562 7.50861 221.071 0 230.333 0H334.979C344.243 0 351.75 7.50858 351.75 16.7709Z",
    fill: "url(#paint0_linear_2951_135)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2951_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.094 117.25V402H131.906V117.25C131.906 107.999 139.406 100.5 148.656 100.5H253.343C262.594 100.5 270.094 107.999 270.094 117.25Z",
    fill: "url(#paint1_linear_2951_135)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.25 217.75V385.249C50.25 394.5 57.7493 402 67.0001 402H188.437V217.75C188.437 208.499 180.938 201 171.687 201H67.0001C57.7493 201 50.25 208.499 50.25 217.75Z",
    fill: "url(#paint2_linear_2951_135)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2951_135",
    x: -1.42715,
    y: 0.499897,
    width: 404.854,
    height: 568.167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.33333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.33333
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2951_135"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 33.3333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 66.6667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2951_135",
    result: "effect2_dropShadow_2951_135"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2951_135",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2951_135",
    x1: 190.531,
    y1: -0.00000420996,
    x2: 363.765,
    y2: 378.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6AD10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C87E0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2951_135",
    x1: 131.895,
    y1: 100.5,
    x2: 277.83,
    y2: 392.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6D751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6AD10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2951_135",
    x1: 50.2387,
    y1: 201,
    x2: 130.596,
    y2: 397.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6D751"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerPrdct);
export default __webpack_public_path__ + "static/media/power-prdct.9e0ccf9577b9520851e6eee9626ce1a4.svg";
export { ForwardRef as ReactComponent };